import {DownloadTabs} from "../components/download/download.tabs";
import {SwitcherComponent} from "./switcher.component";
import {PriceStore} from "../store/price.store";
import {NewsStore} from "../store/news.store";
import { DownloadPlatformPage } from '../pages/download/download.platform.page';
import { currentUrl, numberSystemDecimal, searchParams } from '../common/consts';
import { DownloadStore } from '../store/download.store';

export class TabControlComponent {
    readonly activeContentFlex: string = 'active-flex';
    readonly activeBlock: string = 'visibility';
    private windowWidth = window.outerWidth;
    private pageSolutionOptions: HTMLInputElement[];
    private tabButtons: HTMLElement[];
    private tabContents: HTMLElement[];
    private tabMobileContents: HTMLElement[];
    private tabParallelContents: HTMLElement[];
    // private tabKindButtons : HTMLElement[];
    private downloadPlatformPage: DownloadPlatformPage;
    constructor(
        private container: HTMLElement,
        private indexTab: number,
        private switchers: HTMLElement[],
        private priceStore: PriceStore,
        private newsStore: NewsStore,
        private searchParams: URLSearchParams,
        private loader: HTMLElement | null,
        private downloadStore: DownloadStore | null,
    ) {
        this.pageSolutionOptions
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-solution-option]'));
        this.tabButtons = Array.prototype.slice.call(this.container.querySelectorAll(`[data-tab-btn]`));
        // this.tabKindButtons = Array.prototype.slice.call(this.container.querySelectorAll(`[data-tab-btn-kind]`));
        this.tabContents = Array.prototype.slice.call(this.container.querySelectorAll(`[data-tab-content]`));
        this.tabMobileContents
            = Array.prototype.slice.call(this.container.querySelectorAll(`[data-tab-content-mobile]`));
        this.tabParallelContents
            = Array.prototype.slice.call(this.container.querySelectorAll(`[data-tab-content-parallel]`));
        this.downloadPlatformPage = new DownloadPlatformPage(
            this.loader,
            this.switchers,
            this.downloadStore = null,
        );
    }

    public initialize(): void {
        const handlerTabs = (
            tabContents: HTMLElement[],
            currentIndex: number,
            attributeName: string,
            indexTab: number | null = null,
            currentIndexTab: number | null = null,
            attributeKind: string
        ) => {
            tabContents.forEach((tabContentItem, index) => {
                const attributeValue = tabContentItem.getAttribute(attributeName) === 'block';
                const isModal
                    = tabContentItem.closest('[data-tab-btn]')?.hasAttribute('data-tab-modal');
                const mobile = ((this.windowWidth <= 980 || isModal)
                    && attributeName === 'data-tab-content-mobile') ?
                    index !== currentIndex : true;
                const order: string | null = tabContentItem.getAttribute(attributeKind);
                const inCaseThereIsLevel = order
                    ? parseInt(
                    order, 10
                ) - 1 === currentIndexTab : true;
                if (
                    tabContentItem.classList.contains(attributeValue ? this.activeBlock : this.activeContentFlex)
                    && mobile
                    && inCaseThereIsLevel
                ) {
                    tabContentItem.classList.remove(attributeValue ? this.activeBlock : this.activeContentFlex);
                }
            });
            if (tabContents && tabContents.length > 0 && tabContents.length - 1 >= currentIndex) {
                const currentAttributeValue = tabContents[currentIndex]
                    .getAttribute(attributeName) === 'block';
                tabContents[currentIndex].classList.toggle(
                    currentAttributeValue
                        ? this.activeBlock
                        : this.activeContentFlex
                );
            }

        }
        // const getMainIndexElement = (item) => {
        //     const element = item.closest('[data-tabs]'); // Как будет время переделаю
        //     const parent = element.parentElement;
        //
        //     return  Array.prototype.indexOf.call(parent.children, element);
        // }


        if (this.tabButtons) {
            const news: HTMLElement | null = document.querySelector('[data-news]');

            this.tabButtons.forEach((tabButton, index) => {
                this.setTabBySearchParameters();
                tabButton.addEventListener('click', (e) => {
                    e.stopImmediatePropagation();
                    if (tabButton.querySelector('h4')?.innerText) {
                        DownloadTabs.setPlatformName(tabButton.querySelector('h4')?.innerText);
                    }

                    if (tabButton.dataset.platformId) {
                        this.downloadPlatformPage.initialize(
                            parseInt(tabButton.dataset.platformId, numberSystemDecimal)
                        );
                    }
                    const controlActive = 'active';
                    if (tabButton.getAttribute('data-tab-btn-kind') === 'solution') {
                        this.priceStore.setSolutionIndex(index);
                    }
                    this.tabButtons.forEach((interfaceTab, clickIndex) => {

                        const mobile = (
                            (this.windowWidth <= 980
                            || interfaceTab.hasAttribute('data-tab-modal'))
                            && tabButton.getAttribute('data-tab-btn') === 'accordion')
                            ? index !== clickIndex : true;
                        const order: string | null = tabButton.getAttribute('data-order');
                        const orderInterfaceTab: string | null = interfaceTab.getAttribute('data-order');
                        const orderInterfaceTabPosition: number | null = orderInterfaceTab
                            ? parseInt(orderInterfaceTab, 10) - 1
                            : null;
                        const inCaseThereIsLevel: boolean = order
                            ? this.indexTab
                            === parseInt(order, 10) - 1
                            && orderInterfaceTabPosition
                            === this.indexTab : true;

                        if (interfaceTab.classList.contains(controlActive) && mobile && inCaseThereIsLevel) {
                            interfaceTab.classList.remove(controlActive);
                        }
                    });

                    if (this.pageSolutionOptions && this.pageSolutionOptions.length > 0) {
                        this.pageSolutionOptions[index].checked = true;
                    }
                    const levelTabButtons: any[] = [];
                    this.tabButtons.forEach((item: HTMLElement) => {
                        const order: string | null = item.getAttribute('data-order');
                        const orderPosition = order ? parseInt(order, 10) - 1 : null;
                        if (this.indexTab === orderPosition) {
                            levelTabButtons.push(item);
                        }
                    });
                    const currentButtons: HTMLElement[] = this.container.getAttribute('data-order')
                        ? levelTabButtons : this.tabButtons;

                    if (currentButtons.length - 1 >= index) {

                        currentButtons[index].classList.toggle(controlActive);
                    }


                    const levelTabContents: HTMLElement[] = [];

                    this.tabContents.forEach((tabContent: HTMLElement) => {
                        const order: string | null = tabContent.getAttribute('data-order');
                        const orderPosition = order ? parseInt(order, 10) - 1 : null;
                        if (
                            this.indexTab === orderPosition
                        ) {
                            levelTabContents.push(tabContent);
                        }
                    });
                    const currentTabContents = this.container.getAttribute('data-order')
                        ? levelTabContents : this.tabContents;
                    const order: string | null = tabButton.getAttribute('data-order');
                    const orderPosition = order ? parseInt(order, 10) - 1 : null;
                    handlerTabs(
                        currentTabContents,
                        index,
                        'data-tab-content',
                        this.indexTab,
                        orderPosition,
                        'data-order'
                    );
                    const levelParallelTabContents: HTMLElement[] = [];
                    this.tabParallelContents.forEach((tabContent: HTMLElement) => {
                        const order: string | null = tabContent.getAttribute('data-order-parallel');
                        const orderPosition = order ? parseInt(order, 10) - 1 : null;
                        if (
                            this.indexTab === orderPosition
                        ) {
                            levelParallelTabContents.push(tabContent);
                        }
                    });
                    const currentParallelTabContents = this.container.getAttribute('data-order-parallel')
                        ? levelParallelTabContents : this.tabParallelContents;
                    const orderParallel: string | null = tabButton.getAttribute('data-order-parallel');

                    const orderParallelPosition = orderParallel ? parseInt(orderParallel, 10) - 1 : null;
                    handlerTabs(
                        currentParallelTabContents,
                        index,
                        'data-tab-content-parallel',
                        this.indexTab,
                        orderParallelPosition,
                        'data-order-parallel'
                    );
                    handlerTabs(
                        this.tabMobileContents,
                        index,
                        'data-tab-content-mobile',
                        null,
                        null,
                        'data-order'
                    );
                    this.switchers.forEach((switcher: HTMLElement) => {
                        new SwitcherComponent(switcher).initialize();
                    });

                    if (tabButton?.dataset && news) {
                        const tabButtonDataset: string = tabButton.dataset.tabBtn as string;

                        searchParams.set("tab", tabButtonDataset)
                        currentUrl.search = searchParams.toString();
                        history.pushState(null, '', currentUrl.toString());
                        this.newsStore.setSelectedTab(tabButtonDataset);
                    }
                });
            });
        }

        const setActiveTab = (tabs: HTMLElement[], active: string) => {
            const tabNodes: HTMLElement[] = [];
            tabs.forEach((tabContent: HTMLElement) => {
                tabNodes.push(tabContent);
            })
            if (tabs && tabs.length > 0 && this.windowWidth > 980
                && tabNodes.every(tab => !tab.classList.contains(active))
            ) {
                tabs[0].classList.add(active);
            }
        }
        window.addEventListener("resize", (event: UIEvent) => {
            const eventCurrentTarget: Window = event.currentTarget as Window
            this.windowWidth = eventCurrentTarget.innerWidth;

            const tabContents: HTMLElement[] = this.tabContents;
            const tabButtons: HTMLElement[] = this.tabContents;
            setActiveTab(tabContents, this.activeContentFlex);
            setActiveTab(tabContents, this.activeBlock);
            setActiveTab(tabButtons, 'active');

        });

    }

    setTabBySearchParameters() {
        if (this.searchParams.get('tab')) {
            const selectedTab = this.tabButtons.findIndex(
                tabButton => tabButton.dataset.tabBtn === this.searchParams.get('tab')
            );
            if (selectedTab !== -1) {
                this.tabButtons.forEach((tabButton: HTMLElement, index: number) => {

                    tabButton.classList.remove('active');
                });
                this.tabContents.forEach((tabContent: HTMLElement) => {

                    tabContent.classList.remove(tabContent.dataset.tabContent === 'flex'
                        ? this.activeContentFlex
                        : this.activeBlock
                    );
                });

                this.tabButtons[selectedTab].classList.add('active');
                this.tabContents[selectedTab]?.classList
                    .add(this.tabContents[selectedTab].dataset.tabContent === 'flex' ?
                        this.activeContentFlex
                        : this.activeBlock
                    );
            }
        }
    }
}
